export const SUPERUSER_SWITCH_MODE_COOKIE_NAME = 'dl_superuser_switch_mode';
export const DISABLE_JSONFN_SWITCH_MODE_COOKIE_NAME = 'dl_disable_json_fn';
